module.exports = __webpack_public_path__ + "static/media/Icn-cfm.72683bda.svg";